import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { getCurrentMarket, subscribeToCurrentMarket, MARKET_FUTURES } from '../../utils/MarketStorage';

// Mostra o MERCADO atual (Spot/Futuros) com ícone no topo do menu + link p/ trocar (tela de cards).
function MarketIndicator() {
    const [market, setMarket] = useState(getCurrentMarket());
    useEffect(() => subscribeToCurrentMarket(setMarket), []);
    const isFutures = market === MARKET_FUTURES;

    return (
        <li className='nav-item mb-2'>
            <Link to='/markets' className='nav-link d-flex align-items-center justify-content-between rounded px-2'
                title='Clique para trocar de mercado'
                style={{ border: `1px solid ${isFutures ? '#f59e0b' : '#3b82f6'}`, background: isFutures ? 'rgba(245,158,11,0.12)' : 'rgba(59,130,246,0.12)', minWidth: 0 }}>
                <span className='d-flex align-items-center text-truncate' style={{ minWidth: 0 }}>
                    <span className='sidebar-icon'>
                        {isFutures
                            ? <svg className='icon icon-xs me-2 text-warning' fill='currentColor' viewBox='0 0 20 20'><path fillRule='evenodd' d='M12 7a1 1 0 110-2h5a1 1 0 011 1v5a1 1 0 11-2 0V8.414l-4.293 4.293a1 1 0 01-1.414 0L8 10.414l-4.293 4.293a1 1 0 01-1.414-1.414l5-5a1 1 0 011.414 0L11 10.586 14.586 7H12z' clipRule='evenodd' /></svg>
                            : <svg className='icon icon-xs me-2 text-primary' fill='currentColor' viewBox='0 0 20 20'><path d='M4 4a2 2 0 00-2 2v1h16V6a2 2 0 00-2-2H4z' /><path fillRule='evenodd' d='M18 9H2v5a2 2 0 002 2h12a2 2 0 002-2V9zM4 13a1 1 0 011-1h1a1 1 0 110 2H5a1 1 0 01-1-1zm5-1a1 1 0 100 2h1a1 1 0 100-2H9z' clipRule='evenodd' /></svg>}
                    </span>
                    <span className='sidebar-text text-truncate'>Mercado: <strong>{isFutures ? 'Futuros' : 'Spot'}</strong></span>
                </span>
                <span className='badge bg-secondary sidebar-text flex-shrink-0 ms-1' style={{ fontSize: '0.6em' }}>trocar ⇄</span>
            </Link>
        </li>
    );
}

export default MarketIndicator;
